<template>
  <div class="privacyModalContent col-xs-12 col-md-7 col-lg-5 paddingToHide">
    <div class="ModalContent__text">
      <div v-if="contentType === 'terms'">
        <p>{{$t('terms.textZero')}}</p>
        <h3>{{$t('terms.titleOne')}}</h3>
        <p>{{$t('terms.textOne')}}</p>
        <h3>{{$t('terms.titleTwo')}}</h3>
        <p>{{$t('terms.textTwo')}}</p>
        <h3>{{$t('terms.titleThree')}}</h3>
        <p>{{$t('terms.textThree')}}</p>
        <h3>{{$t('terms.titleFour')}}</h3>
        <p v-html="$t('terms.textFour')"></p>
        <h3>{{$t('terms.titleFive')}}</h3>
        <p>{{$t('terms.textFive')}}</p>
        <h3>{{$t('terms.titleSix')}}</h3>
        <p>{{$t('terms.textSix')}}</p>
        <h3>{{$t('terms.titleSeven')}}</h3>
        <p>{{$t('terms.textSeven')}}</p>
        <h3>{{$t('terms.titleEight')}}</h3>
        <p>{{$t('terms.textEight')}}</p>
        <h3>{{$t('terms.titleNine')}}</h3>
        <p>{{$t('terms.textNine')}}</p>
      </div>

      <div v-if="contentType === 'privacy'">
        <h3 class="text-center">{{$t('privacy.titleZero')}}</h3>
        <p v-html="$t('privacy.textZero')"></p>
        <h3>
          <b>1.{{$t('privacy.titleOne')}}</b>
        </h3>
        <p class="pl-2" v-html="$t('privacy.textOne')"></p>
        <h3>
          <b>2.{{$t('privacy.titleTwo')}}</b>
        </h3>
        <h3 class="pl-2">
          <b>2.1 {{$t('privacy.firstSubtitleTwo')}}</b>
        </h3>
        <p class="pl-4" v-html="$t('privacy.firstTextSubtitleTwo')"></p>
        <h3 class="pl-2">
          <b>2.2 {{$t('privacy.secondSubtitleTwo')}}</b>
        </h3>
        <p class="pl-4" v-html="$t('privacy.secondTextSubtitleTwo')"></p>
        <h3 class="pl-2">
          <b>2.3 {{$t('privacy.thirdSubtitleTwo')}}</b>
        </h3>
        <p class="pl-4" v-html="$t('privacy.firstTextSubtitleThree')"></p>
        <h3 class="pl-2">
          <b>2.4 {{$t('privacy.fourthSubtitleTwo')}}</b>
        </h3>
        <p class="pl-4" v-html="$t('privacy.firstTextSubtitleFour')"></p>
        <h3 class="pl-2">
          <b>2.5 {{$t('privacy.fifthSubtitleTwo')}}</b>
        </h3>
        <p class="pl-4" v-html="$t('privacy.firstTextSubtitleFive')"></p>
        <h3 class="pl-2">
          <b>2.6 {{$t('privacy.sixthSubtitleTwo')}}</b>
        </h3>
        <p class="pl-4" v-html="$t('privacy.firstTextSubtitleSix')"></p>
        <h3>
          <b>3.{{$t('privacy.titleThree')}}</b>
        </h3>
        <p class="pl-2" v-html="$t('privacy.firstSubtitleThree')"></p>
        <p class="pl-4" v-html="$t('privacy.firstTextSubtitleOne')"></p>
        <h3>
          <b>4.{{$t('privacy.fourthTitle')}}</b>
        </h3>
        <p class="pl-2" v-html="$t('privacy.fourText')"></p>
      </div>

      <div v-if="contentType === 'gdpr'">
        {{ $t('gdpr.generic') }}
      </div>
    </div>
    <div class="stickyBtn">
      <button
        @click="$emit('closeModal')"
        class="btn btn-primary mt-4 mb-4 w-100"
      >{{$t('general.accept')}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contentType: {
      type: String,
      required: true,
    }
  }
};
</script>

<style lang="scss" scoped>
.privacyModal {
  width: 100%;
  min-height: 100vh;
}
.ModalContent {
  &__text {
    padding: 90px 8px 75px 0;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    height: calc(100vh);
    width: 100%;
    overflow-y: scroll;
    word-break: break-word;
  }
}
.privacyModalContent {
  width: 100%;
  height: 100%;
  background: white;
  z-index: 2;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
}
.stickyBtn {
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  width: 100%;
  left: 0;
  width: 100%;
  padding: 2px 15px;
}
</style>